export default {"src":"/_next/static/media/eyes.6218bb54.svg","height":22,"width":22,"blurWidth":0,"blurHeight":0};